/**
 * Locale loader — each language is a separate webpack chunk loaded on demand.
 *
 * Previously all 3 languages (~200KB of JSON) were statically imported into
 * main.js. Now main only contains this tiny loader; the actual translation
 * bundle for the user's language is fetched as an async chunk on first render
 * and cached in memory.
 */

/** List of supported UI languages. */
export const supportedLangs = ["en", "ru", "he"];
export const defaultLang = "en";

const cache = {};

/**
 * Dynamically load a locale bundle. Each call produces a separate webpack
 * chunk (one per language). Subsequent calls return the cached result.
 *
 * @param {string} lang  — one of supportedLangs
 * @returns {Promise<object>} merged dictionary for the language
 */
export async function loadLocale(lang) {
  const key = supportedLangs.includes(lang) ? lang : defaultLang;
  if (cache[key]) return cache[key];

  let mod;
  switch (key) {
    case "ru":
      mod = await import(/* webpackChunkName: "i18n-ru" */ "./locales/ru");
      break;
    case "he":
      mod = await import(/* webpackChunkName: "i18n-he" */ "./locales/he");
      break;
    case "en":
    default:
      mod = await import(/* webpackChunkName: "i18n-en" */ "./locales/en");
      break;
  }
  cache[key] = mod.default || mod;
  return cache[key];
}

/**
 * Deprecated — kept as empty stub so legacy imports of `translations` don't
 * crash during rollout. Remove once no file imports it.
 */
export const translations = { en: {}, ru: {}, he: {} };
